import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const ItemContainer = styled(Group)`
  padding: ${rem(8)};

  ${mediaQueryUp.tablet} {
    width: ${rem(267)};
    padding: ${rem(16)};
  }
`

function TourV2BookWithConfidenceItem(props: App.Tours.V2OfferBookWithConfidenceItem) {
  const { title, description, Icon } = props

  return (
    <ItemContainer direction="vertical" gap={4} horizontalAlign="center">
      <Icon size="L" type="primary" />
      <BodyText variant="large" weight="bold" align="center">{title}</BodyText>
      <BodyText variant="medium" align="center">{description}</BodyText>
    </ItemContainer>
  )
}

export default TourV2BookWithConfidenceItem
